import { render, staticRenderFns } from "./DotsLoader.vue?vue&type=template&id=d2ce457a&scoped=true&"
import script from "./DotsLoader.vue?vue&type=script&lang=js&"
export * from "./DotsLoader.vue?vue&type=script&lang=js&"
import style0 from "./DotsLoader.vue?vue&type=style&index=0&id=d2ce457a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ce457a",
  null
  
)

export default component.exports